import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Scrollbar } from '../../../../components/atoms/scrollbar';

import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';
import { Destination } from '@/features/destinations/api/types/destination';

interface Props {
  destinations: Destination[];
  isLoading: boolean;
}

export const DestinationsTable = ({ destinations, isLoading }: Props) => {
  const { t } = useTranslation(['destinations']);

  const columns = [
    {
      id: 'name',
      label: t('destinations:table.name'),
    },
    {
      id: 'floor',
      label: t('destinations:table.floor'),
    },
    {
      id: 'description',
      label: t('destinations:table.description'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <Scrollbar>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {destinations?.map(destination => (
              <TableRow hover key={destination.id}>
                <TableCell>{destination.name}</TableCell>
                <TableCell>{destination.floor}</TableCell>
                <TableCell>{destination.description}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
      <DataStatusIndicator dataLength={destinations?.length} error="" isFetching={isLoading} />
    </Box>
  );
};
